import { Component } from '@angular/core'

@Component({
  selector: 'se-po-minor-account-not-found',
  templateUrl: './minor-account-not-found.component.html',
  styleUrls: ['./minor-account-not-found.component.scss'],
  standalone: false,
})
export class MinorAccountNotFoundComponent {}
